var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{attrs:{"type":"text","value":_vm.value,"mask":_vm.maskArray,"show-mask":_vm.showMask,"guide":true,"placeholder":_vm.text},on:{"focusin":_vm.onPhoneFocus,"blur":_vm.onPhoneBlur,"input":_vm.updateField}})
}
var staticRenderFns = []

export { render, staticRenderFns }